import { ProfileHeader } from "@components/profile-header";
import { ProjectStandaloneSwitch } from "@pages/project-profile/project-standalone-switch";
import { BaseProjectProps } from "@custom-types/base-types";

/** Display Project information in the header of project profile page */
export function ProjectProfileHeader({
  project,
}: BaseProjectProps): React.JSX.Element {
  return (
    <ProfileHeader
      type="PROJECT"
      name={project.name}
      subheaderElement={<ProjectStandaloneSwitch project={project} />}
    />
  );
}
